<div class="content p-24">
    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

            <div class="h2 mb-24">{{'User data'|translate}}</div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'First name'|translate}}</mat-label>
                    <input matInput formControlName="firstName" required>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>{{'First Name is required!'|translate}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                    <mat-label>{{'Last name'|translate}}</mat-label>
                    <input matInput formControlName="lastName" required>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>{{'Last Name is required!'|translate}}</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                    <mat-label>E-mail</mat-label>
                    <input matInput formControlName="email" required>
                    <mat-icon matSuffix class="secondary-text">email</mat-icon>
                    <mat-error>{{'E-mail is required!'|translate}}</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pl-4">
                    <mat-label>{{'Phone'|translate}}</mat-label>
                    <input matInput formControlName="phone">
                    <mat-icon matSuffix class="secondary-text">phone_iphone</mat-icon>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Password'|translate}}</mat-label>
                    <input matInput formControlName="plainPassword">
                    <mat-icon matSuffix class="secondary-text">warning</mat-icon>
                    <mat-error>{{'Password is required!'|translate}}</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Street'|translate}}</mat-label>
                    <input matInput formControlName="street">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="25" class="pl-4">
                    <mat-label>{{'House number'|translate}}</mat-label>
                    <input matInput formControlName="houseNumber">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="25" class="pl-4">
                    <mat-label>{{'Flat number'|translate}}</mat-label>
                    <input matInput formControlName="flatNumber">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="20" class="pr-4">
                    <mat-label>{{'Post code'|translate}}</mat-label>
                    <input matInput formControlName="postCode">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="40" class="pl-4">
                    <mat-label>{{'City'|translate}}</mat-label>
                    <input matInput formControlName="city">
                    <mat-icon matSuffix class="secondary-text">home</mat-icon>
                </mat-form-field>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="40">
                        <mat-label>{{'Country'|translate}}</mat-label>
                        <mat-select formControlName="country">
                            <mat-option [value]="country.id" *ngFor="let country of countries">
                                {{country.name}}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                        <mat-error>Country is required!</mat-error>
                    </mat-form-field>
                </div>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Role'|translate}}</mat-label>
                    <mat-select formControlName="roles" [(value)]="userData.roles" [compareWith]="compareStrings" multiple>
                        <mat-option [value]="role" *ngFor="let role of roles">
                            {{ role|translate }}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Services'|translate}}</mat-label>
                    <mat-select placeholder="{{'Services'|translate}}" [compareWith]="compareObjects" formControlName="services" [(value)]="userData.services" multiple>
                        <mat-option *ngFor="let service of services" [value]="service">{{service.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="visibleInScheduler" fxFlex="25">
                    <mat-label>{{'Visible in scheduler'|translate}}</mat-label>
                </mat-checkbox>
                <mat-checkbox formControlName="visibleInCalendar" fxFlex="25">
                    <mat-label>{{'Visible in calendar'|translate}}</mat-label>
                </mat-checkbox>

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Calendar priority'|translate}}</mat-label>
                    <input matInput formControlName="calendarPriority" required type="number">
                    <mat-error>{{'Calendar priority is required!'|translate}}</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <button mat-raised-button type="submit" color="accent">
                        {{'Save'|translate}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
